import { useTranslation } from "react-i18next"

import { BankAccountDetails } from "./components/BankAccountDetails"
import { SepaAdvisor } from "./components/SepaAdvisor"
import { Pearl, PearlProvider } from "@oysterhr/pearl"
import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"
import { ReusableWizard } from "@oysterhr/feature-components"
import { StripeSepaWrapper } from "./components/StripeSepaWrapper"
import { AuthorizeDebitStep } from "./steps/AuthorizeDebitStep"

const SepaFlowPage = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")

  return (
    <PearlProvider>
      <ConnectPaymentMethodLayout title={t("title")} subtitle={t("subtitle")}>
        <ReusableWizard>
          <StripeSepaWrapper>
            <BankAccountDetails />
          </StripeSepaWrapper>
          <AuthorizeDebitStep />
        </ReusableWizard>

        <div className="text-left">
          <Pearl name="sepa-bank-details">
            <Pearl.SideBox>
              <SepaAdvisor />
            </Pearl.SideBox>
          </Pearl>
        </div>
      </ConnectPaymentMethodLayout>
    </PearlProvider>
  )
}

export default SepaFlowPage
